var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C12 1 4 9.15327 4 14.3137C4 18.5959 7.543 22 12 22C16.457 22 20 18.5959 20 14.3137C20 9.15327 12 1 12 1ZM12 20.0784C8.635 20.0784 6 17.5467 6 14.3137C6 11.6187 9.253 7.02896 12.001 3.89294C14.749 7.02608 18 11.6119 18 14.3137C18 17.5467 15.365 20.0784 12 20.0784Z",
    fill: "currentColor"
  })));
}
export default SvgDropreact;